import React, { Component } from 'react';
import HeaderNotifications from './HeaderNotifications';
import HeaderUserMenu from './HeaderUserMenu';
import HeaderPinLoginMenu from './HeaderPinLoginMenu';
import { HttpRequestService } from './services/HttpRequestService';

class HeaderNav extends Component {

  constructor(props) {
    super(props);
    this.state = {
      user: null
    }
    this.http = new HttpRequestService();
    this.getUser = this.getUser.bind(this);
  }

  componentDidMount() {
    this.getUser()
  }

  getUser() {
    this.http.getSilent('/api/PowerD/GetLoggedInUser', null).then(data => {
      localStorage.setItem("email", data.email);
      localStorage.setItem("username", data.userName);
      this.setState({ user: data });
      console.log(data);
    });
  }

  canSeeNotifications(){
    const roles = this.state.user.roles;
    return roles && (roles.indexOf("Order") >= 0 || roles.indexOf("Admin") >= 0);
  }

  render() {
    return (
      <nav className="navbar navbar-header navbar-expand-lg" >
        {this.state.user &&
          <div className="container-fluid">
            {localStorage.getItem("loginType") !== "pin" &&
              <ul className="navbar-nav topbar-nav ml-md-auto align-items-center">
                {this.canSeeNotifications() &&
                  <HeaderNotifications user={this.state.user}></HeaderNotifications>
                }
                <HeaderUserMenu user={this.state.user}></HeaderUserMenu>
              </ul>
            }
            {localStorage.getItem("loginType") === "pin" &&
              <HeaderPinLoginMenu user={this.state.user}></HeaderPinLoginMenu>
            }
          </div>
        }
      </nav>

    )
  }
}
export default HeaderNav
